module.exports = __webpack_public_path__ + "static/img/74路.a687a27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/74路.jpg
// module id = NG6T
// module chunks = 2